//needed
//var variantFirstID = "";
//var metafields_array = [];

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();




/* the variant class */
theme.Variants = (function() {
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.selectors = options.selectors;
    this.settings = options.settings;
    var options = this._getCurrentOptions();
    this.currentVariant = this._getVariantFromOptions(options);
    $(this.selectors.singleOptionSelector).on('change', this._onSelectChange.bind(this));
  }
  
  Variants.prototype = _.assignIn({}, Variants.prototype, {
    _getCurrentOptions: function() {

      return _.map($(this.selectors.singleOptionSelector, this.$container), function(select) {
        return $(select).val();
      });
    },

    _getVariantFromOptions: function(selectedValues) {
      var variants = this.product.variants;

      if (typeof nonStandardProduct === 'undefined') {

        var found = _.find(variants, function(variant) {
          return selectedValues.every(function(value) {
            return (variant.id.toString().indexOf(value) !== -1);
          });
        });
      } else {
      	var found = _.find(variants, function(variant) {
        	return selectedValues.every(function(value) {
          		return (variant.options.indexOf(value) !== -1);
        	});
      	});
      }
      return found;
    },
        

    _onSelectChange: function() {
      var options = this._getCurrentOptions();
      var variant = this._getVariantFromOptions(options);
      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        product: this.product
      });
      if (!variant) {
      }

      this._updateMasterSelect(variant);
      if(variant){
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateInventoryStatus(variant);

    }

      this._updateVariantColor(variant);
      this.currentVariant = variant;
      
      
      if (this.settings.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    
    _updateImages: function(variant, product) {
      if(variant){
      var variantImage = variant.featured_image || {};

      if(!this.currentVariant === "undefined" || !this.currentVariant === null){
              var currentVariantImage = this.currentVariant.featured_image || {};
      }
      if (!variant.featured_image) {
        return;
      }
      //if(!currentVariantImage.src === "undefined")
      //if (variantImage.src === currentVariantImage.src)


      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
        product: this.product
      });
    }},
    
    /* Holt added */
    _updateInventoryStatus: function(variant) {
      if (variant.inventory_quantity == 0) {
        $(this.selectors.inventoryStatus).addClass('outofstock');
      } else {
        $(this.selectors.inventoryStatus).removeClass('outofstock');
      };

    },
    
  
    _updateVariantColor: function(variant) {
      if(variant) {
        var varTitle = variant.title;
        varTitle.replace("Replacement Lenses","");
        $(this.selectors.variantColorText).text(varTitle);
      };
    },

    /* end Holt */
    
    _updatePrice: function(variant) {
      /*if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }*/
      

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateHistoryState: function(variant) {
      if (!history.pushState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    _updateMasterSelect: function(variant) {
      var $originalSelector = $(this.selectors.originalSelectorId);
	  
      if (!variant || !$originalSelector.length) {
          return;
      }

      $originalSelector.find("option:selected").prop("selected", false);
      $originalSelector.find("option").each(function() {
        if ($(this).val() == variant.id && variant.available) {
          $(this).prop("selected", true);
        } else if ($.trim($(this).text()) == $.trim(variant.title) + " - Sold out") {
          $(this).prop("selected", true);
          return false;
        } else {
          $(this).prop("selected", false);
        }
      });
    },  
  });
  return Variants;
})();

// Utility helpers for product section scoped DOM lookups
function getActiveProductSectionId(sectionId) {
  if (sectionId) return sectionId;
  if (window.theme && window.theme.activeProductSectionId) {
    return window.theme.activeProductSectionId;
  }
  var productSection = document.querySelector('[data-section-type="product"]');
  return productSection ? productSection.getAttribute('data-section-id') : null;
}

function getProductElement(baseId, sectionId) {
  var id = getActiveProductSectionId(sectionId);
  return id ? document.getElementById(baseId + '-' + id) : null;
}

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on('click.drawer', $.proxy(function() {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function(evt) {
      var $el = $(this);

      if (!$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit'
  };

  var classes = {
    focus: 'search--focus'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function() {
      $(selectors.searchHeader).toggleClass(classes.focus);
    });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {onDrawerOpen: searchDrawerFocus});
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight() + cache.$siteHeader.offset().top;

    cache.$mobileNavContainer
      .prepareTransition()
      .addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, ' + 0 + 'px, 0)'
    });
    cache.$pageContainer.css({
      transform: 'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$mobileNav,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, -100%, 0)'
      
    });
    cache.$pageContainer.removeAttr('style');

    cache.$mobileNavContainer.one('TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle', function() {
      slate.a11y.removeTrapFocus({
        $container: cache.$mobileNav,
        namespace: 'navFocus'
      });
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $('.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]')
        .removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {

    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav
        .prepareTransition()
        .addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu[0].scrollHeight;
    if (!target) {
      translateMenuHeight = $targetMenu.outerHeight();
    }

    var openNavClass = menuLevel > 2
      ? classes.thirdNavShowing
      : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one('TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle', function() {
      slate.a11y.trapFocus({
        $container: $targetMenu,
        $elementToFocus: $elementToFocus,
        namespace: 'subNavFocus'
      });

      cache.$mobileNavContainer.off('.subnavToggle');
      isTransitioning = false;
    });

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translate3d(0, ' + translateMenuHeight + 'px, 0)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init
  };
})(jQuery);

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function() {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });

})();

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();




/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by',
    DEFAULT_SORT: 'title-ascending'
  };
  var selectors = {
    filterSelection: '.filters-toolbar__input--filter',
    sortSelection: '.filters-toolbar__input--sort',
    defaultSort: '.filters-toolbar__default-sort'
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      var query = '';

      this.sort = this._getSortValue();

      if (this.sort !== this.defaultSort) {
        query = [constants.SORT_BY + '=' + this.sort];
      }

      var search = document.location.search = query.length ? '?' + query : '';

      document.location.href = this.$filterSelect.val() + search;
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      document.location.href = this.$filterSelect.val() + document.location.search;
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val() || constants.DEFAULT_SORT;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    if (!window.theme) {
      window.theme = {};
    }
    window.theme.activeProductSectionId = sectionId;

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      
      lensView: '#lensView',
      
      variantColorText: '#VariantColorText-' + sectionId,
      inventoryStatus: '#InventoryStatus-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      //originalSelectorId: '.SingleOptionSelector-' + sectionId,
      productFeaturedImage: '#FeaturedImage-' + sectionId,
      productImageWrap: '#FeaturedImageZoom-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);

    this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
    this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr('src'));

    if (this.settings.zoomEnabled) {
      this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data('zoom'));
    }
    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          if (self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.productImageWrap));
          }

          self.settings.bpSmall = false;
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        settings: this.settings,
        selectors: this.selectors,
        product: this.productSingleObject
      }
      this.variants = new theme.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));

      // ---------- ATC Button Updater ----------
      (function bindUpsellRecalc(self){
        var ids = ['concierge-add-on','frame-case-add-on','anti-fog-add-on','screwdriver-add-on'];

        function schedule() {
          setTimeout(function(){
            self._updatePrice({ variant: self.variants && self.variants.currentVariant });
          }, 0);
        }

        ids.forEach(function(id){
          var el = document.getElementById(id);
          if (!el) return;
          el.addEventListener('change', schedule);
          el.addEventListener('input', schedule);
          el.addEventListener('click', schedule);
        });

        // seed once (covers forced Concierge on load)
        schedule();
      })(this);
    },
    // ------------------------------------------
    
//swatches start
    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }
      var self = this;
      var starterTier = this.variants.currentVariant.sku.split('-')[1]
      var starterUnavailableTier = starterTier;
      if (starterUnavailableTier.startsWith("E")){
        starterUnavailableTier = starterUnavailableTier.slice(1)
      }
      if (starterUnavailableTier.startsWith("AM") || starterUnavailableTier.startsWith("ZS")){
        starterUnavailableTier = starterUnavailableTier.slice(2)
      }
      if (starterUnavailableTier.endsWith("P")){
        starterUnavailableTier = starterUnavailableTier.slice(0,-1)
      }
      
      availabilityCheckerTiers(starterUnavailableTier)
      if (starterTier.startsWith("AM") || starterTier.startsWith("EAM") || starterTier.includes("V26")){
        document.getElementById("AMP-tier").classList.add('selected-tier');
      } else if (starterTier.startsWith("ZS") || starterTier.startsWith("EZS")){
        document.getElementById("Pro-tier").classList.add('selected-tier');
      }else {
        document.getElementById("Standard-tier").classList.add('selected-tier');
      }

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var imageSrc = $el.attr('href');
		    var zoomSrc = '';
        var nonLensProductTypes = ['APPAREL', 'ACCESSORIES', 'POPS'];
        var uniqueColors = ['PH', 'CLBL', 'CAR', 'YAR', 'AMV26'];
        var pattern = /\d/;
        var forceUnavailableAmp = ['AMMNBLP'] // FORCE UNAVAILABLE - REMOVE WHEN MIDNIGHT IS AVAILABLE
        var forceUnavailableAmp8Base = ['EAMMNBLP'] // FORCE UNAVAILABLE - REMOVE WHEN MIDNIGHT IS AVAILABLE
        if ((typeof custom_lens_product !== 'undefined') || typeof window.meta.product !== 'undefined' && nonLensProductTypes.indexOf(window.meta.product.type.toUpperCase()) === -1) {
          var standardColor, polarColor, plusColor,ampColor;
          var colorId = this.id

          if (typeof swatch_data[colorId] !== 'undefined') {
            standardColor = swatch_data[colorId];
          } else if (typeof swatch_data["E"+colorId] !== 'undefined') {
          	standardColor = swatch_data["E"+colorId];
          } else {
          	standardColor = false;
          }
         
          if (typeof swatch_data[colorId+"P"] !== 'undefined') {
                polarColor = swatch_data[colorId+"P"];
              } else if (typeof swatch_data["E"+colorId+"P"] !== 'undefined') {
                polarColor = swatch_data["E"+colorId+"P"];
              } else {
                polarColor = false;
          }
          
          if (typeof swatch_data["ZS"+colorId+"P"] !== 'undefined') {
            plusColor = swatch_data["ZS"+colorId+"P"];
          } else if (typeof swatch_data["EZS"+colorId+"P"] !== 'undefined') {
          	plusColor = swatch_data["EZS"+colorId+"P"];
          } else {
          	plusColor = false;
          }
          
      //     if (typeof swatch_data["AM"+colorId+"P"] !== 'undefined') {
      //         ampColor = swatch_data["AM"+colorId+"P"];
      //     } else if (typeof swatch_data["EAM"+colorId+"P"] !== 'undefined') {
      //     	  ampColor = swatch_data["EAM"+colorId+"P"];
      //     }
      //      else {
      //     	ampColor = false;
      //     }
      //     if (typeof swatch_data["AM"+colorId] !== 'undefined'){
      //       ampColor = swatch_data["AM"+colorId];
      //     } else if (typeof swatch_data["EAM"+colorId] !== 'undefined'){
      //       ampColor = swatch_data["EAM"+colorId];
      //     }   
 
      // }
      // UNCOMMENT ^^ WHEN AMMNBLP BECOMES AVAILABLE
          
          if (typeof swatch_data["AM"+colorId+"P"] !== 'undefined' && !forceUnavailableAmp.includes("AM"+colorId+"P")) {
            ampColor = swatch_data["AM"+colorId+"P"];
          } else if (typeof swatch_data["EAM"+colorId+"P"] !== 'undefined' && !forceUnavailableAmp8Base.includes("EAM"+colorId+"P")) {
            ampColor = swatch_data["EAM"+colorId+"P"];
          }
           else {
            ampColor = false;
          }
          if (typeof swatch_data["AM"+colorId] !== 'undefined' && !forceUnavailableAmp.includes("AM"+colorId+"P")){
            ampColor = swatch_data["AM"+colorId];
          } else if (typeof swatch_data["EAM"+colorId] !== 'undefined' && !forceUnavailableAmp8Base.includes("EAM"+colorId+"P")){
            ampColor = swatch_data["EAM"+colorId];
          } 
  
        }
          // DELETE ^^ WHEN AMMNBLP BECOMES AVAILABLE
          
        if(document.querySelector('.selected-tier').id =="Standard-tier"){
          variantData = standardColor
          imageSrc = standardColor.tier_featured_image;
          swatchId = this.id

          if(document.getElementById('ampCornerTag')){document.getElementById('ampCornerTag').style.opacity = 0;}
        }


        if(document.querySelector('.selected-tier').id =="Pro-tier"){
          variantData = plusColor
          imageSrc = plusColor.tier_featured_image;
          swatchId = "ZS"+this.id+"P"

          if(document.getElementById('ampCornerTag')){document.getElementById('ampCornerTag').style.opacity = 0;}
        }
        if(document.querySelector('.selected-tier').id =="AMP-tier"){
          variantData = ampColor
          imageSrc = ampColor.tier_featured_image;
          swatchId = "AM"+this.id

          if(document.getElementById('ampCornerTag')){document.getElementById('ampCornerTag').style.opacity = 0.6;}
        }     
          

        $('.single-option-selector').val(variantData.variant_id).change();
          if(document.getElementById("swatch-attributes-container")){
            attributesUpdater(variantData.color_code)
          }
 
        self._setActiveThumbnail(swatchId);
       //handleOutOfStock(stockData,swatchId);
       if(variantData){
         if(document.getElementById('color-availability-span') && variantData.available == true)
         {document.getElementById('color-availability-span').classList.remove('inline-grid')
          greyUnavailable("no"); 
        } else {
          if(document.getElementById('color-availability-span')){
        document.getElementById('color-availability-span').classList.add('inline-grid')
        greyUnavailable("no"); 

          }
        }
                setColorTitle(variantData)
                setLensFeatures(variantData);
                setLensSwatchClone()  

       } else {
         if(document.getElementById('color-availability-span')){
          document.getElementById('color-availability-span').classList.add('inline-grid')
        }
         greyUnavailable("yes"); 
       }
        setFeaturedImage2(variantData, self.settings.sectionId); //good
        setAltImages(variantData); //good 
        self._switchImage(imageSrc, zoomSrc);
        swatchClickAction(swatchId);

      });

    },


    _setActiveThumbnail: function(swatchId) {
      var skuId;
      var newSkuId;
      var elId

      if (this.variants.currentVariant) {
        var isolatedSku = this.variants.currentVariant.sku.split("-")[1];
        if (isolatedSku.endsWith("6O")) {
          elId = isolatedSku.replace("6O","");
        } else if (isolatedSku.endsWith("63")) {
          elId = isolatedSku.replace("63","");
        } else {
          elId = isolatedSku;
        }
      }

      var thumbnail;
      var activeThumb = 'active-thumb';
      //console.log(elId);
      if(elId.startsWith('ZS') || elId.startsWith("AM")){
        skuId = elId.slice(2);
      } else {
        skuId = elId;
      }
      if(skuId.endsWith('PP')){
        skuId = skuId.slice(0, -1);
      }      
      if(skuId.endsWith('P')){
        skuId = skuId.slice(0, -1);
      }



      if (typeof swatchId === 'undefined' || swatchId === null) {
          if(skuId.startsWith('E')){
            thumbnail = document.getElementById(skuId.substring(1));
          }else {
          thumbnail = document.getElementById(skuId);
          }
      } else {

      	  thumbnail = document.getElementById(swatchId);
        }
      $(this.selectors.productThumbImages).removeClass(activeThumb);
      if (typeof thumbnail === 'undefined' || thumbnail === null) {
       if(skuId.startsWith('EZS') || skuId.startsWith('EAM')){ 
        newSkuId = skuId.slice(3);
        document.getElementById(newSkuId).classList.add(activeThumb)
      }else if(skuId.startsWith('E')){
        newSkuId = skuId.slice(1)
        document.getElementById(newSkuId).classList.add(activeThumb);
        }else { 
        document.getElementById(skuId).classList.add(activeThumb);
        }
        return;
      } else {
      	thumbnail.classList.add(activeThumb);
      }

    },

    _switchImage: function(image, zoomImage) {
      $(this.selectors.productFeaturedImage).attr('src', image);

      // destroy image zooming if enabled
      if (this.settings.zoomEnabled) {
        _destroyZoom($(this.selectors.productImageWrap));
      }

      if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {s
        $(this.selectors.productImageWrap).data('zoom', zoomImage);
        _enableZoom($(this.selectors.productImageWrap));
      }
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;
      if (variant) {
        //'AMP Glacier', 'AMP Carbon'//
    
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true');
        
        if (variant.available) {
            $(this.selectors.addToCart).prop('disabled', false);
            $(this.selectors.addToCartText).text(theme.strings.addToCart);
            if(document.getElementById('show-bundles-bottom')){
            document.getElementById('show-bundles-bottom').classList.remove("inactive");
            document.getElementById('show-bundles-bottom').innerHTML = "ADD";
            }

            if(document.getElementById("AddToCart-product-fuse-frame")) {
              document.getElementById("AddToCart-product-fuse-frame").removeAttribute("disabled");    
              document.getElementById("AddToCartText-product-fuse-frame").innerHTML = theme.strings.addToCart;
            }        
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          if(document.getElementById('show-bundles-bottom')){
            document.getElementById('show-bundles-bottom').classList.add("inactive");
            document.getElementById('show-bundles-bottom').innerHTML = "SOLD OUT";
          }
          if(document.getElementById("AddToCart-product-fuse-frame")) {
              document.getElementById("AddToCart-product-fuse-frame").setAttribute("disabled", true);    
              document.getElementById("AddToCartText-product-fuse-frame").innerHTML = "SOLD OUT";

          }

        }
      } else {
        
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        if(document.getElementById('show-bundles-bottom')){
        document.getElementById('show-bundles-bottom').classList.add("inactive");
        document.getElementById('show-bundles-bottom').innerHTML = "N/A";
        }

        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false');

          if(document.getElementById("AddToCart-product-fuse-frame")) {
              document.getElementById("AddToCart-product-fuse-frame").setAttribute("disabled", true);    
              document.getElementById("AddToCartText-product-fuse-frame").innerHTML = "Unavailable";

          }
        }
    },

    _updateImages: function(evt) {
      var lensProductTypes = ["Fuse Lenses", "Fuse Frames", "Custom Lenses"];
      if (lensProductTypes.indexOf(evt.product.type) == -1) {
        if (evt.product.type != "Apparel") {
          var variant = evt.variant;
          var variantSkuSplit = variant.sku.split('-');
          var imgSrc = tier_image_links[variantSkuSplit[1]].image_src.replace("_small", "");
          var sizedImgUrl = theme.Images.getSizedImageUrl(imgSrc, this.settings.imageSize);
          var zoomSizedImgUrl;
          if (this.settings.zoomEnabled) {
            zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
          }
          this._switchImage(sizedImgUrl, zoomSizedImgUrl);
          this._setActiveThumbnail(sizedImgUrl);
        } else {
          var imgSrc = non_lens_img_sources[evt.variant.id].image_src.replace("_small", "");
          var sizedImgUrl = theme.Images.getSizedImageUrl(imgSrc, this.settings.imageSize);
          var zoomSizedImgUrl;
          if (this.settings.zoomEnabled) {
            zoomSizedImgUrl = theme.Images.getSizedImageUrl(evt.variant.featured_image.src, this.settings.imageZoomSize);
          }
          this._switchImage(sizedImgUrl, zoomSizedImgUrl);
          this._setActiveThumbnail(sizedImgUrl);
        }
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      $(this.selectors.originalPrice).attr('data-variant-id',variant.id);
      var stickyPrice = document.getElementById('ProductStickyPrice-' + this.settings.sectionId);
      if (stickyPrice){
        stickyPrice.innerHTML = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
      }

      // Update compare/sale UI
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
          .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
        $(this.selectors.saleLabel).removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }

      // === ATC text (variant price + selected upsells) ===
      const $btn = $(this.selectors.addToCart);
      const $txt = $(this.selectors.addToCartText);
      if ($txt.length) {
        const base = theme.strings.addToCart; // use base string, avoid stale captures
        const isOn = (el) => !!el && (el.checked || el.value === 'Yes');

        const saleCurrentlyActive = window.saleConfig.tierEnabled;
        const enableAccessoriesDiscount = window.saleConfig.enableAccessoryDiscount;
        const accessoriesDiscountNumber = (1 - window.saleConfig.discountsPct?.ACCESSORIES) / 100;

        const hasAccDiscount = !!saleCurrentlyActive && !!enableAccessoriesDiscount && accessoriesDiscountNumber > 0 && accessoriesDiscountNumber < 1;

        let count = 1, extraCents = 0;
        ['frame-case-add-on','anti-fog-add-on','concierge-add-on','screwdriver-add-on'].forEach((id) => {
          const el = document.getElementById(id);
          if (!isOn(el)) return;

          const unit = el.closest('.upsell-unit');
          if (!unit) return;

          const selector = (saleCurrentlyActive && enableAccessoriesDiscount && id !== 'concierge-add-on')
            ? '.new-accessory-price'
            : '.warranty-price';

          let priceEl = unit.querySelector(selector);
          if (!priceEl || !priceEl.textContent || !priceEl.textContent.trim()) {
            priceEl = unit.querySelector('.warranty-price'); // fallback
            if (!priceEl) return;
          }

          const raw = priceEl.textContent.replace(/[^\d.]/g, '');
          const cents = Math.round((parseFloat(raw || '0')) * 100);

          extraCents += cents;
          count += 1;
        });

        // --- base product price (use discounted display if present) ---
        const parseCents = (s) => Math.round((parseFloat((s || '').replace(/[^\d.]/g, '')) || 0) * 100);
        const discountEl = document.getElementById('discountPrice'); // your sale display element
        const baseCents = (discountEl && discountEl.textContent.trim())
          ? parseCents(discountEl.textContent)   // discounted base during sales
          : (evt.variant ? evt.variant.price : 0); // regular base otherwise

        // --- total + render ---
        if (evt.variant && evt.variant.available && $btn.length && !$btn.prop('disabled')) {
          const totalCents = baseCents + extraCents;
          const label = (count > 1) ? `Add ${count} items to cart` : base;
          $txt.text(`${label}`);
        } else {
          $txt.text(base);
        }
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom($el) {
    var zoomUrl = $el.data('zoom');
    $el.zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom($el) {
    $el.trigger('zoom.destroy');
  }

  return Product;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

};

$(theme.init);

//$(document).ready(function() {
  function swatchClickAction(swatchId) {

    handleDiscountPrice();
    singlesDiscountPrice();

  	if (typeof nonStandardProduct === 'undefined') {
        var nonLensProductTypes = ['APPAREL', 'ACCESSORIES', 'POPS'];
      	if (typeof window.meta.product !== 'undefined' && nonLensProductTypes.indexOf(window.meta.product.type.toUpperCase()) !== -1) {
          /*
          * The next conditional is for custom hats. The only reason it exist here, so that the change in the single-option-selector
          * is compatible with the swatch change - like the lenses logic
          */
          if (window.meta.product.variants[0].sku.substring(0,2) == 'HT') {
            $('.single-option-selector').val(this.childNodes[1].dataset.vId).change();
          }
        } else {
          if (window.meta.product.type === "Fuse Frames") {
            var optionElements = document.getElementById("SingleOptionSelector-0");
			      //var selectedOptionId = optionElements.options[optionElements.selectedIndex].id;
            handleSunglassesColorChange(swatchId);
          } else {
          }
        }
    } 
  }
  
  const productSingleThumbs = document.getElementsByClassName('product-single__thumbnail');
  /*for (var i = 0; i < productSingleThumbs.length; i++) {
    productSingleThumbs[i].addEventListener('click', swatchClickAction);
  } */
  
//});
/////
var selectCallback = function(variant, selector) {

    if (variant) {
      $('.variant-sku').text(variant.sku);
    }
    else {
      $('.variant-sku').empty();
    }

    self.productPage({
      money_format: theme.moneyFormat,
      variant: variant,
      selector: selector,
      translations: {
        add_to_cart : theme.productStrings.addToCart,
        sold_out : theme.productStrings.soldOut,
        unavailable : theme.productStrings.unavailable,
        pre_order: theme.productStrings.preOrder
      }
    });
};

  //function handleOutOfStock(nextColorCode, tierInputEl, swatchId) {
    function handleOutOfStock(stockData, swatchId) {

    var mirrorList = ['CBM', 'SSM', 'BL', 'GR', 'GM', 'NOV', 'PM', 'RG', 'MNBL', 'ONG', 'YM', 'AMCBM','AMBL'];
    var mirrored = false;
    var ampList = ['AMG', 'AMB', 'AMCBM', 'AMBL'];
    var amp = false;
    for (let index in mirrorList) {
      if (mirrorList[index] === swatchId) {
      	mirrored = true;
      }
    }
     for (let index in ampList) {
       if (ampList[index] === swatchId){
       amp = true;
       }
     }
    var standardColor, polarColor, polarArColor;
    var standardPrice = mirrored === true ? '$29.99' : '$24.99';
    if (amp === false){
      var polarPrice = mirrored === true ? '$44.99' : '$39.99';
    //document.getElementById('polar-text').innerHTML = "Polarized <span id='polar-price'>" + polarPrice + "</span>";

    } else {
      var polarPrice = mirrored === true ? '$69.99' : '$64.99';
      //document.getElementById('polar-text').innerHTML = "Color Enhancing + Anti-Reflective <span id='polar-price'>" + polarPrice + "</span>";



    }
    var plusPrice = mirrored === true ? '$54.99' : '$49.99';
    var outOfStock = 'OUT OF STOCK';

    //start of new out of stock check
    if (stockData){
      var sectionId = getActiveProductSectionId();
      var addToCartTextEl = getProductElement('AddToCartText', sectionId);
      var showBundlesBtn = document.getElementById("show-bundles");
      var showBundlesBottom = document.getElementById("show-bundles-bottom");

      if (stockData.available === true){
        if(addToCartTextEl){
          addToCartTextEl.disabled = false;
          if(addToCartTextEl.classList.contains("preorder-button-color")){
            addToCartTextEl.innerText = "Pre Order Now";
          }
        }

        if(showBundlesBtn){
          if(showBundlesBtn.classList.contains("preorder-button-color")){
            showBundlesBtn.innerText = "Pre Order Now";
          }
          showBundlesBtn.classList.remove("out-of-stock-button-color");
          showBundlesBtn.disabled = false;
        }

        if(showBundlesBottom){
          showBundlesBottom.disabled = false;
          showBundlesBottom.classList.remove("sticky-btn--sold-out");
        }
      }
      else{ 
        if(addToCartTextEl){
          addToCartTextEl.innerHTML = "Sold out";
        }
        if(showBundlesBtn){
          showBundlesBtn.innerText = "Sold out";
          showBundlesBtn.disabled = true; 
          showBundlesBtn.classList.add("sticky-btn--sold-out");

          if(showBundlesBottom){
            showBundlesBottom.innerText = "Sold out";
            showBundlesBottom.disabled = true; 
            showBundlesBottom.classList.add("sticky-btn--sold-out");
          }
        }
      }
    }
  }
  
  function handleSunglassesColorChange(selectedOptionId) {
    var activeSwatch = document.getElementsByClassName("active-thumb");
    var swatchId = activeSwatch[0].id.replace('-Pro','');
    var standardColor, polarColor, plusColor,ampColor;
    var colorId = selectedOptionId
    if (swatchId === "cloned-swatch-image") {
    	activeSwatch = document.getElementsByClassName("active-thumb");
      	swatchId = activeSwatch[1].id;
    }
    var variantData, tierInputEl;

    if(colorId.startsWith("AM") && !colorId.endsWith("V26")){
      colorId = colorId + "P"
    }
    if (typeof swatch_data[colorId] !== 'undefined') {
      standardColor = swatch_data[colorId];
      imageSrc = standardColor.tier_featured_image;
      swatchId = this.id
    } else if (typeof swatch_data[colorId] == 'undefined') { // if typeof was 'undefined', the 'swatch_data' object likely contains 8B color codes
      standardColor = swatch_data["E" + colorId];
      imageSrc = standardColor.tier_featured_image;
      swatchId = this.id
    }
   
    variantData = standardColor
  if(variantData){
      addAltImages(swatch_data[variantData.color_code]);
      setColorTitleSunglasses(variantData);
      setLensFeatures(variantData);
      setWarranty(variantData);
      setLensSwatchClone();

  }
  }


  function setLensFeatures(variantData) {
    var lensFeatures;
    for (key in colorCodeFeatures) {
      if (key.indexOf(" "+variantData.color_code+" ") !== -1) {
        lensFeatures = colorCodeFeatures[key];
      }
    }
  	var descriptionElAcc = document.getElementById('color-description-acc');
    var descriptionElAccMobile = document.getElementById('color-description-acc-clone');
    var descriptionElDeet = document.getElementById('color-description');
    var lensViewAcc = document.getElementById('lensView');
    var lensViewAccMobile = document.getElementById('lensView-clone');
    var lensViewDeet = document.getElementById('lensView2');
    var lensCategoryAcc = document.getElementById('lensCategory');
    var lensCategoryAccMobile = document.getElementById('lensCategory-clone');
    var lensCategoryDeet = document.getElementById('lensCategory2');
    var environmentIconSpan = document.getElementById('environment-icon');// environment icon for slide 1
    var activityIconSpan = document.getElementById('best-for-activity-icon');// envirnonment icon for slide 1
    var lensActivity = document.getElementById('activities-icon-container');
    var lensVlt = document.getElementById('lensVlt');
    var lensVltNumber = document.getElementById('lensVltNumber');
    var lensVltRange = document.getElementById('lensVltRange');
    var environmentIcon = lensFeatures['ideal-for'];    
    var vltIdealFor = document.getElementById('lensVltIdealFor')
    // lens_details snippet variables
    var lensDetails_desc = document.getElementById('lens-details_color-description')
    var lensDetails_view = document.getElementById('lens-details_lensView2')
    var lensDetailsVltNumber = document.getElementById('lensDetailsVltNumber')
    var lensDetails_VltRange = document.getElementById('lensDetailsVltRange')
   
    if (descriptionElAcc) descriptionElAcc.innerHTML = lensFeatures['lens-color'];
    if (descriptionElAccMobile) descriptionElAccMobile.innerHTML = lensFeatures['lens-color'];
    if (descriptionElDeet) descriptionElDeet.innerHTML = lensFeatures['lens-color'];
    if (lensDetails_desc) lensDetails_desc.innerHTML = lensFeatures['lens-color'];
  
    if (lensViewAcc) lensViewAcc.innerHTML = lensFeatures['lens-view'];
    if (lensViewAccMobile) lensViewAccMobile.innerHTML = lensFeatures['lens-view'];
    if (lensViewDeet) lensViewDeet.innerHTML = lensFeatures['lens-view'];
    if (lensDetails_view) lensDetails_view.innerHTML = lensFeatures['lens-view']

    if (lensCategoryAcc) lensCategoryAcc.innerHTML = lensFeatures['lens-category'];
    if (lensCategoryAccMobile) lensCategoryAccMobile.innerHTML = lensFeatures['lens-category'];
    if (lensCategoryDeet) lensCategoryDeet.innerHTML = lensFeatures['lens-category'];
    
    var lensVltNumberValue = lensFeatures['vlt'];
    if(lensVltNumber){
          lensVltNumber.innerText = 'VLT ' + lensVltNumberValue + '%';
    // lensDetailsVltNumber.innerText = 'VLT ' + lensVltNumberValue + '%';
    }

                    
    
    
  if (document.getElementById('lensVltIdealFor')){
    //let environmentIcon = document.getElementById('environment-icon')
    let vltIdealFor = document.getElementById('lensVltIdealFor');
    let environment = 'activity-icon lens-vlt-icon--'
   vltIdealFor.innerHTML = lensFeatures['ideal-for']
   
    if (lensFeatures['ideal-for'].includes('Bright')){
    //environmentIcon.classList = environment + 'bright-light'
    vltIdealFor.innerText = "Ideal for Bright Light"
    //lensVltRange.classList = "vlt-range vlt-range_bright-light"
    lensDetailsVltRange.classList = 'vlt-range vlt-range_bright-light'
  }
  if (document.getElementById('best-for-slide_text')){
    document.getElementById('best-for-slide_text').innerText = lensFeatures['best-for'].toLowerCase().replace("-"," ")
  }
  if (lensFeatures['ideal-for'].includes('Overcast')){
    //environmentIcon.classList = environment + 'mixed-light'  
    vltIdealFor.innerText = "Ideal for Mixed Light"
    //lensVltRange.classList = "vlt-range vlt-range_mixed-light"
    lensDetailsVltRange.classList = 'vlt-range vlt-range_mixed-light'
  }
    
  if (lensFeatures['ideal-for'].includes('Indoors')){
    //environmentIcon.classList = environment + 'low-light'  
    vltIdealFor.innerText = "Ideal for Low Light"
    //lensVltRange.classList = "vlt-range vlt-range_low-light"
    lensDetailsVltRange.classList = 'vlt-range vlt-range_low-light'
  }
  }
  // holt low stock 
    if (document.getElementById('lowStockAlert')) {
      let lowStockAlert = document.getElementById('lowStockAlert');
      var stockLevel = lensFeatures['oos']

      if(stockLevel === true) {
        lowStockAlert.classList = 'lowStock'
        document.getElementById('color-availability-span').classList.remove('inline-grid');
      } else {
        lowStockAlert.classList = 'regStock'
      }
      
      
    }

    if (document.getElementById('stickyLowStockAlert')) {
      let lowStockAlertSticky = document.getElementById('stickyLowStockAlert');
      var stockLevel = lensFeatures['oos']
      if(stockLevel === true) {
        lowStockAlertSticky.classList = 'lowStock'
      } else {
        lowStockAlertSticky.classList = 'regStock'
      }
      
      
    }
    // end holt low stock
    

    if (lensActivity) {      
      var lensActivityString = lensFeatures['activities'];
      var lensActivityString = lensActivityString.toLowerCase();
      var lensActivityArray = lensActivityString.split(", ");            
      var [var1, var2, ...remaining] = lensActivityArray;
      var lensActivityUpdated = []
      for (let i = 0; i < lensActivityArray.length; i++) {
          lensActivityArray[i] = lensActivityArray[i][0].toUpperCase() + lensActivityArray[i].substr(1);
      }
      var lensBestForString = lensFeatures['best-for'];      
      var lensBestForString = lensBestForString.toLowerCase();
      var lensBestForClass = "activity-icon activity-icon--" + lensBestForString;
      var lensBestForStringText = lensBestForString[0].replace("-"," ").toUpperCase() + lensBestForString.substr(1)
      var lensActivitiesAll = document.getElementById('activities-all_list');
      var lensDetailsActivitiesAll = document.getElementById('lens-details__best-activities');
      var bestForSlideText = document.getElementById('best-for-slide_text')
      lensDetailsActivitiesAll.innerHTML = ""
      lensActivitiesAll.innerHTML = ""
      
      for(let g = 0; g < lensActivityArray.length; g++) {
        var li = document.createElement('li')
        var span = document.createElement('span')
        var activ = lensActivityArray[g] 
        var activClass = "activity-icon activity-icon--" + activ.toLowerCase()
        activ = activ.replace("-"," ");        
        li.innerText = activ
        li.classList = activClass
        
        var li2 = document.createElement('li')
        var span2 = document.createElement('span')
        var activ2 = lensActivityArray[g]
        var activ2Class = "activity-icon activity-icon--" + activ2.toLowerCase()
        activ2 = activ2.replace("-"," ");        
        //li2.innerText = activ2
        li2.classList = activ2Class

        lensDetailsActivitiesAll.appendChild(li)
        lensActivitiesAll.appendChild(li2)
        if (g === 3) { break; }
      }
      //lensActivity.innerHTML = lensBestForStringText; 
      lensBestForStringText = lensBestForStringText.replace("-"," ")
      //bestForSlideText.innerText = lensBestForStringText
      lensActivity.classList = lensBestForClass;
      //activityIconSpan.classList = lensBestForClass;
    }


  }

  function setLensSwatchClone() {
    var selectedSwatchClass;
    var swatchImageLoader = document.getElementsByClassName('swatch');
    var clonedSwatchImageId = document.getElementById('cloned-swatch-image');
    var stickyclonedSwatchImageId = document.getElementById('cloned-sticky-swatch-image');
    var lensDetailsSwatchImg = document.getElementById('lens-details_cloned-swatch-image');
    
    for (let i = 0; i < swatchImageLoader.length; i++) {
      if (swatchImageLoader[i].parentNode.classList.contains('active-thumb')) {
        selectedSwatchClass = swatchImageLoader[i].classList.value;
        break;
      }
    }
    clonedSwatchImageId.classList = selectedSwatchClass;
    stickyclonedSwatchImageId.classList = selectedSwatchClass;
    if (lensDetailsSwatchImg){
    lensDetailsSwatchImg.classList = selectedSwatchClass
  }
}

  function setColorTitle(variantData) {
    var colorTitleEl = document.getElementById('colorTitle');
    var lensDetails_colorTitle = document.getElementById('lens-details_colorTitle');
      if (colorTitleEl) {
      var colorTitleFiltered = variantData.title.replace(/Fuse|\+Plus|Preferred|Standard|Tint|Replacement|Lenses|Lens/g,'');
      if(lensDetails_colorTitle){
            lensDetails_colorTitle.innerHTML = colorTitleFiltered;  
      }
        if(colorTitleFiltered.includes('Non-Polarized')|| !colorTitleFiltered.includes('Polarized')){
          var colorTitleFiltered = colorTitleFiltered.replace(/Non-Polarized/g,'');

            colorTitleEl.innerHTML = '<span id="justTheColorTitle">' + colorTitleFiltered + '</span><span class="tag tag--non-polarized">Non-Polarized</span>';
            if(document.getElementById('colorStickyTitle')){ // for sticky footer
              var colorTitleSticky = document.getElementById('colorStickyTitle'); 
              colorTitleSticky.innerHTML = colorTitleFiltered + '<span class="tag tag--non-polarized">Non-Polarized</span>';
            }
        } else {
          var colorTitleFiltered = colorTitleFiltered.replace(/Polarized/g,'');
          colorTitleEl.innerHTML = '<span id="justTheColorTitle">' + colorTitleFiltered + '</span><span class="tag tag--polarized">Polarized</span>';
            if(document.getElementById('colorStickyTitle')){ // for sticky footer
              var colorTitleSticky = document.getElementById('colorStickyTitle'); 
              colorTitleSticky.innerHTML = colorTitleFiltered + '<span class="tag tag--polarized">Polarized</span>';
            }
        }  
      }
    }
  
  function setColorTitleSunglasses(variantData) {
    var colorTitleEl = document.getElementById('colorTitle');
    var colorTitleFiltered = variantData.title.replace(/Fuse|\+Plus|Preferred|Standard|Tint|Replacement|Lenses/g,'');
    colorTitleEl.innerHTML = colorTitleFiltered;
  }

  function setAltImages(variantData) {
    if(variantData){
    var altImageRootSrc = "https://cdn.shopify.com/s/files/1/1542/2169/files/";

      // top frames stuff    
    var frameImageRootSrc = "https://img.fuselenses.com/TOPFRAMES/";
    var frameImagePathEnd = "/PHOTOS/STUDIO/ANGLE/MEDIUM/";
    var frameThumbImagePathEnd = "/PHOTOS/STUDIO/ANGLE/SMALL/";
    var frameProductHandle;
    var topFrameBrand;
    var currentColor = variantData.color_code;

    if (variantData.color_code.startsWith("E")) { // remove 8-base 'e' prefix
      var currentColor = variantData.color_code.substring(1);
    }
      
    if (document.URL.includes('oakley')) {
      var frameProductHandle = document.URL.match(/\oakley[^?/]+/)[0].toUpperCase();
      topFrameBrand = "OAKLEY";
      if (/^.*-\d+$/.test(frameProductHandle)) { // remove dash and consecutive numbers (flaks)
        frameProductHandle = frameProductHandle.replace(/-\d+$/, '');
      }
    } else if (document.URL.includes('ray-ban')) {
      frameProductHandle = document.URL.match(/ray-ban-[^?/]+(?=-\d+mm)/)[0].toUpperCase();
      topFrameBrand = "RAY-BAN";
    } else if (document.URL.includes('costa-del-mar')) {
      var frameProductHandle = document.URL.match(/costa-del-mar[^?/]+/)[0].toUpperCase();
      topFrameBrand = "COSTA-DEL-MAR";
    }
      
    if (topFrameBrand != undefined) {
      var lensInFrames;
        lensInFrames = frameImageRootSrc + topFrameBrand + "/" + frameProductHandle + frameImagePathEnd + currentColor.toLowerCase() + ".jpg";
        lensInFramesThumb = frameImageRootSrc + topFrameBrand + "/" + frameProductHandle + frameThumbImagePathEnd + currentColor.toLowerCase() + ".jpg";

      if (document.getElementById('topFrameImg')) document.getElementById('topFrameImg').src = lensInFrames;
      if (document.getElementById('topFrameThumbImg')) document.getElementById('topFrameThumbImg').src = lensInFramesThumb;
    }
      // console.log(oakleyProductHandle);
      // console.log(oakleyLensInFrames);

      
    // top frames stuff end

          for (let i = 0; i < altImages.length; i++) {
      	if (altImages[i].color_codes.indexOf(variantData.color_code) !== -1) {
          var altImgSrc1 = altImages[i].images[0]["alt-1"];
          var altImgSrc2 = altImages[i].images[0]["alt-2"];
          var altImgSrc2Thumb = altImages[i].images[0]["alt-2th"];
          var altImgSrc3 = altImages[i].images[0]["alt-3"];
          var altImgSrc3Thumb = altImages[i].images[0]["alt-3"];
          var altImgSrc4 = altImages[i].images[0]["alt-4"];
          var altImgSrc4Thumb = altImages[i].images[0]["alt-4"];
          var altImgSim0 = altImages[i].images[0]["sim-0"];
          var altImgSim = altImages[i].images[0]["sim-1"];
          var altImgSim2 = altImages[i].images[0]["sim-2"];
          var altImgSim2Thumb = altImages[i].images[0]["sim-3"];
          if (typeof isAShieldPage !== 'undefined' && isAShieldPage == true) { // isAShieldPage is defined in product template, true if product has "Shield" tag
            var altImgSrcAct = altImages[i].images[0]["shield-1"];
            var altImgSrcActThumb = altImages[i].images[0]["shield-1-th"];
          } else {
            var altImgSrcAct = altImages[i].images[0]["alt-act"];
            var altImgSrcActThumb = altImages[i].images[0]["alt-act-th"];
          }
          var simCircle = altImages[i].images[0]["sim-circle"];
          var simCircleThumb = altImages[i].images[0]["sim-circle-thumb"];
          var altSimName = altImages[i].color;
          break;
        }
    }
      
	var colorCode = variantData.color_code;
    if(document.getElementById('guarantee-overlay')) document.getElementById('guarantee-overlay').className = colorCode;
    if (document.getElementById('altImg1')) document.getElementById('altImg1').src = altImageRootSrc+altImgSrc1;
    if (document.getElementById('altImg2')) document.getElementById('altImg2').src = altImageRootSrc+altImgSrc2;
    if (document.getElementById('altImg2Thumb')) document.getElementById('altImg2Thumb').src = altImageRootSrc+altImgSrc2Thumb;
    if (document.getElementById('altImg3')) document.getElementById('altImg3').src = altImageRootSrc+altImgSrc3;
    if (document.getElementById('altImg3Thumb')) document.getElementById('altImg3Thumb').src = altImageRootSrc+altImgSrc3Thumb;    
    if (document.getElementById('altImg4')) document.getElementById('altImg4').src = altImageRootSrc+altImgSrc1;
    if (document.getElementById('altImg4Thumb')) document.getElementById('altImg4Thumb').src = altImageRootSrc+altImgSrc4Thumb;
    if (document.getElementById('altImgSrcAct')) document.getElementById('altImgSrcAct').src = altImageRootSrc+altImgSrcAct; 
    if (document.getElementById('altImgSrcActThumb')) document.getElementById('altImgSrcActThumb').src = altImageRootSrc+altImgSrcActThumb; 
    
    if (document.getElementById('simCircle')) document.getElementById('simCircle').src = altImageRootSrc+simCircle;
    if (document.getElementById('simCircleThumb')) document.getElementById('simCircleThumb').src = altImageRootSrc+simCircleThumb;
    if (document.getElementById('original-image')) document.getElementById('original-image').src = altImageRootSrc+altImgSim0;
    if (document.getElementById('simImg')) document.getElementById('simImg').src = altImageRootSrc+altImgSim;
	  if (document.getElementById('simImg2')) document.getElementById('simImg2').src = altImageRootSrc+altImgSim2;
    if (document.getElementById('simImg2Thumb')) document.getElementById('simImg2Thumb').src = altImageRootSrc+altImgSim2Thumb;
  var colorName2Alt = document.getElementById('colorName2');
  if (colorName2Alt) colorName2Alt.innerHTML = altSimName+" Lens";
  }
}
  function setFeaturedImage2(variantData, sectionId) {
    var featuredImage = getProductElement('FeaturedImage', sectionId);
    var featuredImageThumb = getProductElement('FeaturedImageThumb', sectionId);
    var featuredImage2 = document.getElementById('FeaturedImage-2');
    var clonedMainImage = document.getElementById('FeaturedImageMobile');
    if(variantData){
         if (featuredImage) featuredImage.src = variantData.tier_featured_image;
    if (featuredImageThumb) featuredImageThumb.src = variantData.tier_featured_image;    
    if (featuredImage2) featuredImage2.src = variantData.tier_featured_image;
    if (clonedMainImage) clonedMainImage.src = variantData.tier_featured_image; 
    }

    
        
    if(document.getElementById('pdp-sticky-img')){ // for sticky footer
      var colorImageSticky = document.getElementById('pdp-sticky-img'); 
      colorImageSticky.src = variantData.tier_featured_image;
    }
    
  }

  function setWarranty(variantData) {
    var warrantyText = 'Lifetime, 1 time replacement';
    var plusColor = variantData.color_code.search("ZS") !== -1 ? true : false;
    if (plusColor) {
    	warrantyText = "Lifetime, 1 time replacement";
    } else {
        warrantyText = "1 year, 1 time replacement";
    }
    if(document.getElementById('warranty2')) document.getElementById('warranty2').innerHTML = warrantyText;
  }

/* international check */
if (sessionStorage.getItem('LocDomestic') === "false"){
 const international_null_items = document.getElementsByClassName("internatioNull");
 for (const international_null_item of international_null_items) {
    international_null_item.style.display = 'none';
 }
}



if (document.getElementById("swatch-tier-container")){
  for (i=0; i<document.getElementsByClassName("tier-button").length; i++){
    //document.getElementsByClassName("tier-button")[i].addEventListener("click", swatchClick);
    document.getElementsByClassName("tier-button")[i].addEventListener("click", availabilityCheckerSwatches);
    
  }
}

for (i = 0; i<document.getElementsByClassName("li-swatch").length; i++){
  document.getElementsByClassName("li-swatch")[i].addEventListener("click", availabilityCheckerTiers);

}


function swatchClick(){
  document.querySelector('.active-thumb').click();
}


function attributesUpdater() {
  if (!document.getElementById("swatch-attributes-container")) {
    return;
  }
  const swatchContainer = document.getElementById("swatch-attributes-container");
  swatchContainer.innerHTML = "";
  let lensAttributes = [];
  
  for (const key in colorCodeAttributes) {
    if (key.indexOf(" " + variantData.color_code + " ") !== -1) {
      lensAttributes = colorCodeAttributes[key]["Attributes"];
      lensAttributes = lensAttributes.split(","); 
    }
  }
  lensAttributes.forEach(attribute => {
    if (isAShieldPage !== "undefined" && isAShieldPage == true) {
      if (document.getElementById("AMP-tier").classList.contains("selected-tier") && attribute == "Anti-Reflective") {
        return;
      }
    }
    const span = document.createElement('span');
    span.classList.add('lens_attribute'); 
    span.classList.add("lens_attribute_"+attribute.replace(/ /g,"-").replace("&","").replace("%","")); // Add subsequent classes based on attribute strings
    span.textContent = attribute;
    swatchContainer.appendChild(span);
  });
}

function availabilityCheckerTiers(starterUnavailableTier) {
    var tierButton = document.getElementsByClassName("tier-button")
    var filteredSwatch;
    if(document.getElementsByClassName('active-thumb')[0]){
        var activeSwatch = document.getElementsByClassName('active-thumb')[0].id
    }
    else {
      var activeSwatch = starterUnavailableTier
    }
  
  for (i = 0; i < tierButton.length; i++) {

    // strip shield color codes from suffixes (bases and polarization --> "60", "P")
    activeSwatch = activeSwatch.replace("6O","");
    activeSwatch = activeSwatch.replace("63","");
    if(activeSwatch.charAt(activeSwatch.length - 1) === 'P') {
      activeSwatch = activeSwatch.slice(0, -1);
    }
    
    if (tierButton[i].id == "Pro-tier") {
      if (typeof swatch_data["ZS"+activeSwatch+"P"] !== 'undefined') {
        filteredSwatch = swatch_data["ZS"+activeSwatch+"P"];
      } else if (typeof swatch_data["EZS"+activeSwatch+"P"] !== 'undefined') {
        filteredSwatch = swatch_data["EZS"+activeSwatch+"P"];
      } else {
        filteredSwatch = false;
      }
    }
   
    if (tierButton[i].id == "AMP-tier") {
      if (activeSwatch =="V26") {
        if (typeof swatch_data["AM"+activeSwatch] !== 'undefined') {
          filteredSwatch = swatch_data["AM"+activeSwatch];
        } else if (typeof swatch_data["EAM"+activeSwatch] !== 'undefined') {
          filteredSwatch = swatch_data["EAM"+activeSwatch];
        } else {
          filteredSwatch = false;
        }
      } else {   
        if (typeof swatch_data["AM"+activeSwatch+"P"] !== 'undefined') {
          filteredSwatch = swatch_data["AM"+activeSwatch+"P"];  
        } else if (typeof swatch_data["EAM"+activeSwatch+"P"] !== 'undefined') {
          filteredSwatch = swatch_data["EAM"+activeSwatch+"P"];
        } else {
          filteredSwatch = false;
        }
      }
    } 
    
     if (tierButton[i].id == "Standard-tier") {
      if (typeof swatch_data[activeSwatch] !== 'undefined') {
        filteredSwatch = swatch_data[activeSwatch];
      } else if (typeof swatch_data["E"+activeSwatch] !== 'undefined') {
        filteredSwatch = swatch_data["E"+activeSwatch];
      } else {
        filteredSwatch = false;
      }
    }

    if (filteredSwatch && filteredSwatch.available == true) {
      tierButton[i].classList.remove("tier-unavailable")  
    } else {
      tierButton[i].classList.add("tier-unavailable")
    }
  }
}

function availabilityCheckerSwatches(){
  var colorId = document.querySelector('.active-thumb').id

  var swatchAvailability = document.getElementsByClassName("product-single__thumbnail")
  var filteredSwatch;
  for(i = 0; i < swatchAvailability.length; i++){
    if(this.id =="Pro-tier"){

      if (typeof swatch_data["ZS"+swatchAvailability[i].id+"P"] !== 'undefined' && swatch_data["ZS"+swatchAvailability[i].id+"P"].available) {
        filteredSwatch = swatch_data["ZS"+swatchAvailability[i].id+"P"];
      } else if (typeof swatch_data["EZS"+swatchAvailability[i].id+"P"] !== 'undefined' && swatch_data["EZS"+swatchAvailability[i].id+"P"].available) {
        filteredSwatch = swatch_data["EZS"+swatchAvailability[i].id+"P"];
      } else {
        filteredSwatch = false;
      }
    }
    if(this.id=="AMP-tier"){
      if(swatchAvailability[i].id =="V26"){

        if (typeof swatch_data["AM"+swatchAvailability[i].id] !== 'undefined' && swatch_data["AM"+swatchAvailability[i].id].available) {
          filteredSwatch = swatch_data["AM"+swatchAvailability[i].id];
        } else if (typeof swatch_data["EAM"+swatchAvailability[i].id] !== 'undefined' && swatch_data["EAM"+swatchAvailability[i].id].available) {
          filteredSwatch = swatch_data["EAM"+swatchAvailability[i].id];
        } else {
          filteredSwatch = false; 
      }
    }
       else {
          if (typeof swatch_data["AM"+swatchAvailability[i].id+"P"] !== 'undefined' && swatch_data["AM"+swatchAvailability[i].id+"P"].available) {
            filteredSwatch = swatch_data["AM"+swatchAvailability[i].id+"P"];
          } else if (typeof swatch_data["EAM"+swatchAvailability[i].id+"P"] !== 'undefined' && swatch_data["EAM"+swatchAvailability[i].id+"P"].available) {
            filteredSwatch = swatch_data["EAM"+swatchAvailability[i].id+"P"];
          } else {
            filteredSwatch = false;
        }
    }
    }


     if(this.id=="Standard-tier"){
      if (typeof swatch_data[swatchAvailability[i].id] !== 'undefined' && swatch_data[swatchAvailability[i].id].available) {
           filteredSwatch = swatch_data[swatchAvailability[i].id];
      } else if (typeof swatch_data["E"+swatchAvailability[i].id] !== 'undefined' && swatch_data["E"+swatchAvailability[i].id].available) {
           filteredSwatch = swatch_data["E"+swatchAvailability[i].id];
      }
      else {
        filteredSwatch = false;
      }    
     }

     if (filteredSwatch == false){
       swatchAvailability[i].classList.add("swatch-unavailable")
       if(document.getElementById('show-bundles-bottom')){
       document.getElementById('show-bundles-bottom').classList.add("swatch-unavailable")
       }
       
       
       
     } else {
      swatchAvailability[i].classList.remove("swatch-unavailable")
      if(document.getElementById('show-bundles-bottom')){
      document.getElementById('show-bundles-bottom').classList.remove("swatch-unavailable")
      }
  
     }
  }



  
  document.querySelector('.active-thumb').click();

}

function greyUnavailable(isUnavailable) {
  if (isUnavailable == "yes") {
    document.getElementById('lowStockAlert').classList.remove("lowStock");
      
    document.getElementById('cloned-swatch-image').classList.add('greyed');
    document.getElementById('cloned-sticky-swatch-image').classList.add('greyed');

    var stickyTitle = document.getElementById('colorStickyTitle');
    document.getElementById('colorTitle').classList.add("unavailable-pill");
    document.getElementById('colorTitle').innerHTML = "Unavailable";
    stickyTitle.classList.add("unavailable-pill");
    stickyTitle.innerHTML = "Unavailable";

    var stickyAttributeTags = stickyTitle.getElementsByClassName('tag');
    for (var i = 0; i < stickyAttributeTags.length; i++) {
      stickyTitle.removeChild(stickyAttributeTags[i]);
    }

    var desktopTitle = document.getElementById("colorTitle");
    var attributeTags = desktopTitle.getElementsByClassName('tag');
    for (var i = 0; i < attributeTags.length; i++) {
      desktopTitle.removeChild(attributeTags[i]);
    }
  } else if (isUnavailable == "no")  {
    document.getElementById('cloned-swatch-image').classList.remove('greyed');
    document.getElementById('cloned-sticky-swatch-image').classList.remove('greyed');

    document.getElementById('colorTitle').classList.remove("unavailable-pill");
    document.getElementById('colorStickyTitle').classList.remove("unavailable-pill");
  }
}


// ---- SALE BOOTSTRAP (reads window.saleConfig) --------------------

// --- sale helpers (unique names to avoid collisions) ---
function saleToList(csv) {
  return (csv || "")
    .split(/[\n,]/)
    .map(s => (s || "").toString().trim())
    .filter(Boolean);
}
function saleNorm(s) {
  return (s || "").toString().trim().toUpperCase();
}
function salePctToMult(p) {
  return 1 - (Number(p) || 0) / 100;
}


/* ---------- Bootstrap globals from window.saleConfig ---------- */
(function () {
  const cfg = window.saleConfig || {};

  // Tiered
  window.saleStatusTier = !!cfg.tierEnabled;
  window.productsWithDiscount = saleToList(cfg.productsWithDiscountCsv);
  window.assignDiscounts = {
    ALL:      salePctToMult(cfg.discountsPct?.ALL),
    AM:       salePctToMult(cfg.discountsPct?.AM),
    ZS:       salePctToMult(cfg.discountsPct?.ZS),
    STANDARD: salePctToMult(cfg.discountsPct?.STANDARD),
    SUNGLASSES: salePctToMult(cfg.discountsPct?.SUNGLASSES)
  };

  if (window.location.pathname.toLowerCase().includes("sunglasses")) {
    window.assignDiscounts.ALL = window.assignDiscounts.SUNGLASSES;
  }

  // Singles
  window.saleStatusSingles = !!cfg.singlesEnabled;
  window.singlesHighList = saleToList(cfg.singlesHighList).map(saleNorm);
  window.singlesMedList  = saleToList(cfg.singlesMedList).map(saleNorm);
  window.singlesLowList  = saleToList(cfg.singlesLowList).map(saleNorm);
  window.highDiscount = salePctToMult(cfg.singlesPct?.high);
  window.medDiscount  = salePctToMult(cfg.singlesPct?.med);
  window.lowDiscount  = salePctToMult(cfg.singlesPct?.low);

  SALE_DEBUG.log("Bootstrap ▶ saleConfig", cfg);
})();

const enableSunglassesDiscount = window.saleConfig.enableSunglassesDiscount; // true or false, Shopify Admin > Customize > Theme Settings > Sale Status > Sunglasses Discount

/* ---------- Tiered discount (ALL / AM / ZS / STANDARD) ---------- */
function handleDiscountPrice() {
  if (window.location.pathname.toLowerCase().includes("sunglasses") && !enableSunglassesDiscount) return;
  const saleStatus = window.saleStatusTier;
  const tokens = window.productsWithDiscount || [];
  const map = window.assignDiscounts || {};

  if (!saleStatus || !window.variantData?.color_code) return;

  // Don’t touch any global colorCode you might rely on elsewhere
  let tierColor = (variantData.color_code || "").toString();
  if (tierColor.indexOf("AM") === -1 && tierColor.indexOf("ZS") === -1 && !tierColor.endsWith("P")) {
    tierColor += "STANDARD";
  }

  const priceEl = getProductElement('ProductPrice');
  const stickyEl = getProductElement('ProductStickyPrice');
  const d1 = document.getElementById('discountPrice');
  const d2 = document.getElementById('stickyDiscountPrice');
  const currentPrice = priceEl?.innerHTML || "";
  if (!currentPrice) return;

  SALE_DEBUG.group(`SALE Tier ▶ code:${tierColor} | tokens:[${tokens.join(", ")}]`);
  SALE_DEBUG.log("assignDiscounts", map);
  SALE_DEBUG.log("raw currentPrice", currentPrice);

  let matched = false;
  let displayedPrice;

  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (!(tierColor.indexOf(token) >= 0 || token === "ALL")) continue;

    matched = true;
    SALE_DEBUG.log("Matched token:", token);

    // Parse number from locales you handle
    let priceNum;
    if (currentPrice.includes("$") || currentPrice.includes("£"))      priceNum = currentPrice.substring(1);
    else if (currentPrice.includes("€"))                                priceNum = currentPrice.substring(1).replace(",", ".");
    else if (currentPrice.includes("¥"))                                priceNum = currentPrice.substring(1).replace(",", "");
    else if (currentPrice.includes("Rs. "))                             priceNum = currentPrice.replace("Rs. ", "").replace(",", "");
    else if (currentPrice.includes("kr"))                               priceNum = currentPrice.replace(" kr", "").replace(",", ".");
    else if (currentPrice.includes("CHF"))                              priceNum = currentPrice.replace("CHF ", "").replace(",", "");
    else if (currentPrice.includes("QAR"))                              priceNum = currentPrice.replace("QAR", "").replace(",", ".");
    else if (currentPrice.includes("NIS"))                              priceNum = currentPrice.replace(" NIS", "");
    else                                                                priceNum = currentPrice.replace(/[^\d.,]/g, '').replace(",", ".");
    priceNum = parseFloat(priceNum);
    SALE_DEBUG.log("parsed priceNum", priceNum);

    let mult = map[token];
    var discountMultiplier = mult;
    if (typeof mult !== "number" || isNaN(mult)) mult = map.ALL; // fallback
    SALE_DEBUG.log("multiplier used", mult, "(~", (1 - mult) * 100, "% off)");

    let salePrice = (priceNum * mult).toFixed(2);
    if (salePrice.slice(-1) === "9" || salePrice.slice(-1) === "4") {
      salePrice = (parseFloat(salePrice) + 0.01).toFixed(2);
    }

    if (currentPrice.includes("$") || currentPrice.includes("£"))      displayedPrice = currentPrice[0] + salePrice;
    else if (currentPrice.includes("€"))                                displayedPrice = "€" + salePrice.replace(".", ",");
    else if (currentPrice.includes("¥"))                                displayedPrice = "¥" + salePrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    else if (currentPrice.includes("Rs. "))                             displayedPrice = "Rs. " + salePrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    else if (currentPrice.includes("kr"))                               displayedPrice = salePrice.replace(".", ",") + " kr";
    else if (currentPrice.includes("CHF"))                              displayedPrice = "CHF " + salePrice;
    else if (currentPrice.includes("QAR"))                              displayedPrice = "QAR " + salePrice.replace(".", ",");
    else if (currentPrice.includes("NIS"))                              displayedPrice = salePrice + " NIS";
    else                                                                displayedPrice = salePrice;

    SALE_DEBUG.log("displayedPrice", displayedPrice);
    break; // first match wins
  }

  if (matched && displayedPrice) {
    priceEl?.classList.add("old-price");
    stickyEl?.classList.add("old-price");
    if (d1) { d1.innerHTML = displayedPrice; d1.setAttribute('data-price-multiplier', discountMultiplier) }
    if (d2) { d2.innerHTML = displayedPrice; d2.setAttribute('data-price-multiplier', discountMultiplier) }
    SALE_DEBUG.log("✔ applied tier discount");
  } else {
    priceEl?.classList.remove("old-price");
    stickyEl?.classList.remove("old-price");
    if (d1) { d1.innerHTML = ""; d1.setAttribute('data-price-multiplier', discountMultiplier) }
    if (d2) { d2.innerHTML = ""; d2.setAttribute('data-price-multiplier', discountMultiplier) }
    SALE_DEBUG.log("✖ no tier discount applied");
  }
  SALE_DEBUG.end();
}

/* ---------- Singles discount (high/med/low lists) ---------- */
function singlesDiscountPrice() {
  if (!window.saleStatusSingles || !window.variantData?.color_code) return;

  const highList = window.singlesHighList || [];
  const medList  = window.singlesMedList  || [];
  const lowList  = window.singlesLowList  || [];

  const thisColorCode = saleNorm(variantData.color_code);

  const priceEl = getProductElement('ProductPrice');
  const stickyEl = getProductElement('ProductStickyPrice');
  const d1 = document.getElementById('discountPrice');
  const d2 = document.getElementById('stickyDiscountPrice');
  const discountMultiplier = window.assignDiscounts?.ALL;
  const currentPrice = priceEl?.innerHTML;
  if (!currentPrice) return;

  const priceNum = parseFloat(currentPrice.replace(/[^0-9.]/g, ""));
  let bucket=null, mult=null, discountPrice=null;

  if (highList.includes(thisColorCode)) { bucket="high"; mult=window.highDiscount; }
  else if (medList.includes(thisColorCode)) { bucket="med"; mult=window.medDiscount; }
  else if (lowList.includes(thisColorCode)) { bucket="low"; mult=window.lowDiscount; }


  if (bucket) {
    discountPrice = "$" + (priceNum * mult).toFixed(2);
    SALE_DEBUG.log(`matched bucket: ${bucket}`, "multiplier", mult, "→ discountPrice", discountPrice);
    priceEl?.classList.add("old-price");
    stickyEl?.classList.add("old-price");
    if (d1) { d1.innerHTML = discountPrice; d1.setAttribute('data-price-multiplier', discountMultiplier); }
    if (d2) { d2.innerHTML = discountPrice; d2.setAttribute('data-price-multiplier', discountMultiplier); }
    SALE_DEBUG.log("✔ applied singles discount");
  } else {
    SALE_DEBUG.log("✖ no singles discount match");
  }
  SALE_DEBUG.end();
}

/* ---------- Swatch click logging + recompute ---------- */
document.addEventListener('click', function(e){
  const swatch = e.target.closest('[data-color-code], [data-value], .swatch__item, .color-swatch');
  if (!swatch) return;
  const label =
    swatch.getAttribute('data-color-code') ||
    swatch.getAttribute('data-value') ||
    (swatch.textContent || "").trim();

  SALE_DEBUG.group(`SWATCH click ▶ ${label}`);
  SALE_DEBUG.log("variantData.color_code (before)", window.variantData?.color_code);

  // Let theme handlers update variantData, then recalc
  setTimeout(() => {
    SALE_DEBUG.log("variantData.color_code (after)", window.variantData?.color_code);
    if (window.saleStatusTier)    handleDiscountPrice();
    if (window.saleStatusSingles) singlesDiscountPrice();

    const baseEl = getProductElement('ProductPrice');
    const discEl = document.getElementById('discountPrice');
    SALE_DEBUG.log("DOM prices → original:", baseEl?.innerHTML, "| discounted:", discEl?.innerHTML);
    SALE_DEBUG.end();
  }, 0);
});
